/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import NProgress from 'nprogress'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SessionStore from '../../store/SessionStore'
import HotelOptionsStore from '../../store/options/HotelOptionsStore'
import RoomOptionsStore from '../../store/options/RoomOptionsStore'
import ToolbarStore from '../../store/reservation/ToolbarStore'
import EventScheduleStore from '../../store/event_schedule/EventScheduleStore'
import EventScheduleEditView from '../../view/pages/event_schedule/EditView'
import SessionAction from '../../action/session'
import EventScheduleAction from '../../action/event_schedule'

class EditContainer extends Component {
  static getStores() {
    return [HotelOptionsStore, RoomOptionsStore, SessionStore, ToolbarStore, EventScheduleStore]
  }

  static calculateState(prevState, props) {
    return {
      hotel_options: HotelOptionsStore.getState(),
      room_options: RoomOptionsStore.getState(),
      session: SessionStore.getState(),
      toolbar: ToolbarStore.getState(),
      schedule: EventScheduleStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    await SessionAction.fetchUserHotels()

    const id = this.state.match.params.id
    if (id) {
      await EventScheduleAction.fetchOne(id)
      if (this.state.schedule.hotel_id) {
        await SessionAction.fetchRoomsByHotelId(this.state.schedule.hotel_id)
      }
    }

    NProgress.done()
  }

  render() {
    return EventScheduleEditView(this.state)
  }
}

export default withRouter(Container.create(EditContainer, { withProps: true }))
